import React from "react";
import Stars from "components/stars";
import { ReactComponent as VerifiedProfile } from "assets/svgs/verified-profile.svg";

const ProductReviews = ({ reviews }) => {
    if (reviews?.length === 0) return null;

    return (
        <div className="flex pt-12 pb-2.5 py-7 flex-col">
            {reviews && (reviews.map((review, index) => (
                <div key={review?.author_name} className={`flex flex-col relative ${index === reviews.length - 1 && "border-b border-b-[#e3e3e3]"}`}>
                    {review?.image ? (
                        <img className="self-center max-h-[900px]" src={review.image} alt={review.content} />
                    ) : (
                        null
                    )}
                    <div className="flex md:px-10 px-2.5 -mt-14 mb-8">
                        <div className="bg-white w-full flex lg:flex-row flex-col p-6">
                            <div className="flex mb-4 lg:mb-0 xl:pr-28 lg:pr-16">
                                <div className="flex w-16 h-16 rounded-1/2 bg-[#646a63] justify-center mr-5 items-center text-white relative">
                                    <p className="text-xl font-bold">
                                        {review?.author_name?.charAt(0)}
                                    </p>
                                    <VerifiedProfile className="absolute -right-1.5 bottom-0" />
                                </div>
                                <div className="flex flex-col">
                                    <p className="font-bold text-[#10222b]">
                                        {review?.author_name}
                                    </p>
                                    <p className="text-[0.563rem] text-[#10222b]">
                                        {review?.author_place}
                                    </p>
                                    <Stars rating={5} className="gap-0" />
                                </div>
                            </div>
                            <p className="md:text-xl xsm:text-base-xs text-xs text-gray-701 font-normal">
                                {review?.content}
                            </p>
                        </div>
                    </div>
                </div>
            )))}
        </div>
    );
};

export default ProductReviews;
